<div class="feature-grid-container" viFeatureGrid viBorderBottom>
  <ng-container *ngIf="serviceTimeBased$ | async | ready as feature">
    <app-feature-list-item
      data-at-service-interval-last-maintenance
      *ngIf="feature?.properties?.lastService?.value as lastService"
      [label]="
        '+INSTALLATIONS.INSTALLATION.MAINTENANCE_INFORMATION.LAST_MAINTENANCE.LABEL' | translate
      "
      [attr.data-feature]="'lastService'"
      [value]="lastService | date: 'short'"
    >
    </app-feature-list-item>
    <app-feature-list-item
      data-at-service-interval-next-maintenance
      *ngIf="feature?.properties?.nextService?.value as nextService"
      [label]="
        '+INSTALLATIONS.INSTALLATION.MAINTENANCE_INFORMATION.NEXT_MAINTENANCE.LABEL' | translate
      "
      [attr.data-feature]="'nextService'"
      [value]="nextService | date: 'short'"
    >
    </app-feature-list-item>

    <mat-form-field mat-select-height-large class="interval-dropdown" *ngIf="intervals">
      <mat-label>{{
        '+INSTALLATIONS.INSTALLATION.MAINTENANCE_INFORMATION.MONTH_INTERVAL.LABEL' | translate
      }}</mat-label>
      <mat-select
        [disabled]="!feature?.commands?.[FeatureCommands.setServiceIntervalMonths]?.isExecutable"
        data-at-service-interval-set-interval-months
        [value]="feature.properties[FeaturePropertyKey.serviceIntervalMonths].value"
        (valueChange)="onSetServiceIntervalMonthsChange($event)"
      >
        <ng-container *ngIf="intervals.length; else oneOptionDropdown">
          <mat-option *ngFor="let interval of intervals" [value]="interval">
            {{ interval }}
          </mat-option>
        </ng-container>
        <ng-template #oneOptionDropdown>
          <mat-option [value]="feature.properties[FeaturePropertyKey.serviceIntervalMonths].value">
            {{ feature.properties[FeaturePropertyKey.serviceIntervalMonths].value }}
          </mat-option>
        </ng-template>
      </mat-select>
    </mat-form-field>
  </ng-container>
</div>
